import { render, staticRenderFns } from "./mallFooterConfig.vue?vue&type=template&id=09e4c4e0&scoped=true"
import script from "./mallFooterConfig.vue?vue&type=script&lang=js"
export * from "./mallFooterConfig.vue?vue&type=script&lang=js"
import style0 from "./mallFooterConfig.vue?vue&type=style&index=0&id=09e4c4e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e4c4e0",
  null
  
)

export default component.exports